export const list = (list = null, ...items) => {
    if (!Array.isArray(list)) {
        if (list) {
            list = [list];
        } else {
            list = [];
        }
    } else {
        list = [...list];
    }
    if (items.length) {
        return list.concat(items);
    }
    return list;
}

export const array_dots = (obj, prefix) => {

    let res = {};

    let keys = Array.isArray(obj) ? [...obj.keys()] : Object.keys(obj || {});
    keys.map((k) => {
        let val = obj[k];
        let key = prefix ? prefix + '.' + k : k;

        if (val && typeof val === 'object') {
            res = {
                ...res,
                ...array_dots(val, key)
            };
        } else if (val && Array.isArray(val)) {
            res = {
                ...res,
                ...array_dots(val, key)
            }
        } else {
            res[key] = val;
        }
    });

    return res;
}